import { useContext, useEffect, useState } from "react";
import { AuthContext } from "../context/AuthProvider";
import { map } from "lodash";
import { fetchWithInterceptor } from "../utils/fetchWithInterceptor";

export default function useGroups(refresh) {
  const authContext = useContext(AuthContext);

  const [groups, setGroups] = useState([]);

  const getGroups = async () => {
    const response = await fetchWithInterceptor(
      `/api/integrations/liquor-connect/groups`,
      {
        method: "GET",
        headers: {
          "Content-Type": "application/json",
          "x-access-token": authContext.getToken(),
        },
      }
    );
    if (response.ok) {
      const data = await response.json();
      setGroups(map(data, (group) => ({ label: group.name, value: group.name })));
    }
  };

  useEffect(() => {
    getGroups();
    //eslint-disable-next-line react-hooks/exhaustive-deps
  }, [refresh])

  return groups;
}